<mat-form-field class="moneytor-input" [ngClass]="class">
  <!-- <mat-label *ngIf="label">{{ label }}</mat-label> -->
  <input
    matInput
    [placeholder]="placeholder"
    [(ngModel)]="model"
    [disabled]="disabled"
    type="text"
    (keyup)="search($event)"
    (ngModelChange)="onModelChange($event)"
    #inputData="ngModel"
    [matAutocomplete]="auto"
    />

  <mt-btn
    matPrefix
    class="icon"
    (onAction)="search(model)"
    [disabled]="disabled"
    >
    <mat-icon class="mt-icon-size">search</mat-icon>
  </mt-btn>

  @if (model) {
    <mt-btn
      matSuffix
      class="circle error small icon"
      (onAction)="clear()"
      [disabled]="disabled"
      >
      <mat-icon class="mt-icon-size">clear</mat-icon>
    </mt-btn>
  }

  <mat-autocomplete #auto="matAutocomplete">
    @for (option of options; track option) {
      <mat-option [value]="option">
        {{ option }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
